export default __webpack_public_path__ + "static/media/19_1_0.a3b2690d.png";